import gql from "graphql-tag";

// dict_id
// items

// essentially a custom type that just removes the items, which is normally the largest piece of the data
export const CustomFetchClientDictionary = gql`
  # query GetClientDictionary($langCd: String!) {
  query GetClientDictionary($targetType: DictionaryTarget!, $conversationId: String!) {
    # GetClientDictionary(langCd: $langCd) {
    getClientDictionary(targetType: $targetType, conversationId: $conversationId) {
      id
      state
      target_id
      target_type
    }
  }
`;
